module.exports = __webpack_public_path__ + "static/media/MullerBlack.f81dc646.otf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/MullerBlack.otf
// module id = 1076
// module chunks = 0